// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import XEUtils from 'xe-utils';
import VXEUtils from 'vxe-utils';

import '@/common.css'; // 项目自定义的全局样式
import '@/assets/fonts/fonts.css'; // 字体文件引用
import api from '@/api';
import dictionary from '@/utils/dictionary';
import { openLoading, closeLoading } from '@/utils/tools';

Vue.component('el-image-viewer', ElImageViewer);
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(XEUtils, VXEUtils, {mounts: ['cookie']});

Vue.prototype.$VUEX = store; // 公共存储值 this.$store未生效
Vue.prototype.$API = api;
Vue.prototype.$DICT = dictionary;

// ———————————— 权限查看控制 v-has ————————————
Vue.directive('has', {
	update: function (el, binding) {
		if (Vue.prototype.$_has(binding.value)) {
			el.style.display = 'inline-block'; // 
		} else {
			el.style.display = 'none';
		}
	},
	bind: function (el, binding) {
		if (Vue.prototype.$_has(binding.value)) {
			// el.style.display = 'block'; // 影响布局
		} else {
			el.style.display = 'none';
		}
	},
});
Vue.prototype.$_has = function (value) {
	if (value === undefined) return false;
	
	var str = '_';
	if (value.indexOf(str) > -1) {
		value = value.replace(str, ':');
	}
	let isExist = false;
	let btnPermissionsStr = store.getters.rolesStr;
	if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
		return false;
	}
	if (btnPermissionsStr.indexOf(value) > -1) {
		isExist = true;
	}
	return isExist;
};

// ———————————— 接口调用时的锁屏 ————————————
Vue.prototype.openLoading = function (flag = true) {
	openLoading();
};
Vue.prototype.closeLoading = function (flag = true) {
	closeLoading();
};

// ————————————设置限制输入框只能输入数字的属性————————————
function onInput(el, ele, binding, vnode) {
	function handle() {
		let val = ele.value;
		// modifiers为修饰符对象，传入了float，则其float属性为true
		if (binding.modifiers.float) {
			// 清除"数字"和"."以外的字符
			val = val.replace(/[^\d.]/g, '');
			// 只保留第一个, 清除多余的.
			val = val.replace(/\.{2,}/g, '.');
			// 第一个字符如果是.号，则补充前缀0
			val = val.replace(/^\./g, '0.');
			// 保留两位或三位小数
			if (binding.value === 2 || binding.value === 3) {
				const str = `^(\\d+)\\.(\\d\{${binding.value}}).*$`;
				const reg = new RegExp(str);
				val = val.replace(reg, '$1.$2');
			}
		} else {
			val = ele.value.replace(/[^\d]/g, '');
		}
		ele.value = val;
	}
	return handle;
}
const numberInput = {
	bind(el, binding, vnode) {
		const ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
		ele.addEventListener('input', onInput(el, ele, binding, vnode), false);
	},
};
Vue.directive('number-input', numberInput);

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js